var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.363 2.635C11.848-.879 6.149-.878 2.635 2.637c-3.514 3.515-3.513 9.214.002 12.728 3.515 3.514 9.214 3.513 12.728-.002C17.053 13.675 18 11.385 18 8.998s-.949-4.675-2.637-6.363zm-1.733 9.902l-.001.001v-.003l-.456.453c-.59.597-1.449.843-2.265.648-.822-.22-1.604-.57-2.316-1.038-.661-.422-1.274-.916-1.827-1.473-.509-.505-.966-1.06-1.365-1.656-.436-.641-.782-1.34-1.026-2.076-.28-.865-.048-1.813.6-2.45l.534-.535c.148-.149.39-.15.539-.001l.001.001 1.686 1.686c.15.149.15.39.001.539l-.001.001-.99.99c-.284.281-.32.728-.084 1.05.358.492.754.954 1.185 1.383.48.482 1.002.921 1.56 1.311.322.225.76.187 1.038-.09l.957-.972c.148-.149.39-.15.539-.001l.001.001 1.689 1.692c.15.149.15.39.001.539z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H18V18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.af10c8ae9084587a355a694001de0348.svg";
export { ForwardRef as ReactComponent };